import React from 'react'
import { LayoutLoggedArea } from '../../components/Common/LayoutLoggedArea'
import { Rules } from '../../components/Rules'
import { FAQ } from '../../components/FAQ'

export const RulesAndFAQ = () => {
  return (
    <LayoutLoggedArea>
      <Rules />
      <FAQ />
    </LayoutLoggedArea>
  )
}
